import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { isThisQuarter } from 'date-fns';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { CreazionePraticaStoreService } from 'src/app/common/creazione-rapida/wizard-creazione/services/creazione-pratica-store.service';
import { AltraParte } from 'src/app/common/models/altraparte';
import { Controparte } from 'src/app/common/models/controparte';
import { Parte } from 'src/app/common/models/parte';
import { Categoria } from 'src/app/common/models/tipologiche/categoria';
import { FormValidationService } from 'src/app/common/services/form-validation.service';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { CreazionePraticaTipologicheService } from 'src/app/pratica/components/wizard-creazione/services/creazione-pratica-tipologiche.service';

@Component({
  selector: 'step-soggetti-terzi-form-associativa',
  templateUrl: './step-soggetti-terzi-form-associativa.component.html',
  styleUrls: ['./step-soggetti-terzi-form-associativa.component.css']
})
export class StepSoggettiTerziFormAssociativaComponent implements OnInit, OnDestroy {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;

  soggettoForm: FormGroup = new FormGroup({});
  @Input() parte: Parte;
  @Output() altraParteChange: EventEmitter<AltraParte> = new EventEmitter<AltraParte>();
  @Output() altraParteEdit: EventEmitter<AltraParte> = new EventEmitter<AltraParte>();
  @Input() suggestedCategory: string | null;
  @Input() altraParte: AltraParte;
  idInput = Math.random() + "ritirato";
  categoriaOptions: Categoria[] = [];
  controparteOptions: Controparte[] = [];
  componentDestroyed$: Subject<void> = new Subject<void>();
  controparteFetched: boolean = false;
  category;
  dataOdierna = new Date().getTime();

  constructor(private campiForm: FormBuilder, private store: CreazionePraticaStoreService, private tipologicheService: CreazionePraticaTipologicheService, private formValidationService: FormValidationService) {
  }


  ngOnInit() {
    this.populateSelect();
    this.createForm();

  }

  createForm() {
    this.soggettoForm = this.campiForm.group({
      categoriaAltraParte: [this.category, Validators.required],
      controparte: [{ value: null, disabled: this.category?.label === 'LEGALE DI CONTROPARTE' ? false : true}],
      ritirato: [this.altraParte?.ritirato || false],
      dataTermine: [{ value: this.altraParte?.dataTermine || null, disabled: true}],
      note: [null]
    });
    this.soggettoForm.get('categoriaAltraParte').valueChanges.pipe(distinctUntilChanged()).subscribe(value => this.onChangeCategoria(value));
    this.soggettoForm.get('ritirato').valueChanges.subscribe(value => this.onRitiratoChange(value));
  }
  populateSelect() {
    this.tipologicheService.getCategorieAltraParte().pipe(takeUntil(this.componentDestroyed$)).subscribe(response =>  {
      this.categoriaOptions = response;
      if(this.suggestedCategory) {
        this.category = this.categoriaOptions.filter(category => category.label === this.suggestedCategory)[0];
        if (this.soggettoForm.get('categoriaAltraParte') && this.soggettoForm.get('controparte')) {
          this.soggettoForm.patchValue({
            categoriaAltraParte: this.category
          });
          this.onChangeCategoria(this.category)
        }

      }
    });
  }

  onRitiratoChange(value: boolean) {
    const dataTermineControl = this.soggettoForm.get('dataTermine');
    if (value) {
      dataTermineControl.enable();
    } else {
      dataTermineControl.setValue(null);
      dataTermineControl.disable();      
    }
  }

  submit(){
    if(this.soggettoForm.valid){
      this.altraParte = this.soggettoForm.getRawValue();
      this.altraParte.parte = this.parte;
      this.altraParte.dataAssociazione=new Date().getTime();
      this.altraParteChange.emit(this.altraParte);
      this.scrollToSection('altre_parti_fascicolo');
    }
  }

  scrollToSection(sectionId: string) {  
    const section = document.getElementById(sectionId);
    console.log('section', section)
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  onChangeCategoria(value: Categoria){
    if(value?.label == "LEGALE DI CONTROPARTE"){
      this.soggettoForm.get("controparte").enable();
      if(this.controparteOptions == null || this.controparteOptions.length == 0) this.populateControparte();
    } else this.soggettoForm.get("controparte").disable();
  }

  populateControparte(){
    this.store.controparti$.pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      this.controparteOptions = response;
      if(this.controparteOptions != null){
        let count = 0;
        for (let controparte of this.controparteOptions) {
          if(!controparte.id){
            controparte.id = 'TEMP'+ count
          }
          count ++;
          controparte.parte.nominativo = (controparte.parte.tipoPersona.label == this.PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA) ?
          controparte.parte.cognome + ' ' + controparte.parte.nome
            : controparte.parte.ragioneSociale;
        };
      }
      else{
        this.controparteOptions = [];
      }
    });
  }

  // onChangeRinunciatario(value: boolean){
  //   value ? this.soggettoForm.get('dataTermine').enable() : this.soggettoForm.get('dataTermine').disable();
  // }

  editAltraParte() {
    if(this.soggettoForm.valid){
      let idAltraParte = this.altraParte.id;
      let cliente = this.altraParte.cliente;
      const documenti = this.altraParte.documenti;
      this.altraParte = this.soggettoForm.getRawValue();
      this.altraParte.documenti = documenti;
      this.altraParte.parte = this.parte;
      this.altraParte.id = idAltraParte;
      this.altraParte.cliente = cliente;
      this.altraParte.dataAssociazione = new Date().getTime();
      this.altraParteEdit.emit(this.altraParte);
    }
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }
}
